import React from 'react';
import { Helmet } from 'react-helmet';

const PREFIX = 'Emory Healthcare |';

export const PageTitle = ({ title }) => (
  <Helmet>
    <title>{`${PREFIX} ${title}`}</title>
  </Helmet>
);
